import { Component, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { UrlConstantsService } from 'src/app/services/url-constants.service';
import { versions } from 'src/app/versions';

@Component({
  selector: 'app-user-forgot-password',
  templateUrl: './user-forgot-password.component.html',
  styleUrls: ['./user-forgot-password.component.scss'],
  standalone: false,
})
export class UserForgotPasswordComponent {
  // Signals: the app does not repaint after async work on its own, so the switch to the
  // confirmation would otherwise never reach the screen.
  readonly isLoading = signal(false);
  readonly submitted = signal(false);
  /** The platform switch for password resets is off. */
  readonly disabled = signal(false);
  readonly versions = versions;

  form = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(
    private http: HttpClient,
    private urls: UrlConstantsService,
  ) {}

  has(error: string): boolean {
    const control = this.form.get('username');
    return !!control && control.touched && control.hasError(error);
  }

  submit(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid || this.isLoading()) return;

    this.isLoading.set(true);
    const done = () => {
      this.isLoading.set(false);
      // Same confirmation on errors too, so the page never reveals which emails have an account.
      this.submitted.set(true);
    };
    this.http.post(this.urls.USER_FORGET_PASSWORD, { username: this.form.value.username?.trim() }).subscribe({
      next: done,
      error: (err: any) => {
        // The error interceptor may hand over the body itself or the full response.
        const errors = err?.error ?? err;
        if (errors?.code === 'password_resets_disabled') {
          this.isLoading.set(false);
          this.disabled.set(true);
          return;
        }
        done();
      },
    });
  }
}
